import React from 'react'
import { withRouteData } from 'react-static'

import Trackable from './Trackable'
import MetaTags from './MetaTags'
import HeroCatalog from '../components/HeroCatalog'
import SearchResults from '../components/SearchResults'

const description =
    'Access many AI vendors via a single integration with up to 23x better performance/price efficiency by using the right model for your specific case.'

const Catalog = ({ pathContentType, category = {} }) => {
    const title = `Intent Catalog / ${category.name || ''}`
    const metatags = {
        title,
        description,
        og: {
            title,
            description,
            url: `https://inten.to/api-platform/ai/${pathContentType}`,
        },
        twitter: {
            title,
            description,
        },
    }

    return (
        <Trackable page="catalog" className="content--light-gray">
            <MetaTags tags={metatags} />
            <HeroCatalog />
            <SearchResults />
        </Trackable>
    )
}

export default withRouteData(Catalog)



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/Catalog.jsx